import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
import _get from "lodash/get";

var _templateObject;

import reboot from 'styled-reboot';
import { rem, lighten } from 'polished';
import { createGlobalStyle, css } from 'styled-components';
import { typographyTheme } from '~typography';
import { baseTheme, baseScrollbarStyles } from '~base-theme';

var globalOptions = function globalOptions(_ref) {
  var theme = _ref.theme;
  return {
    fontFamilyBase: _get(theme, 'typography.base.fontFamily', typographyTheme.typography.base.fontFamily),
    linkColor: _get(theme, 'typography.link.color', typographyTheme.typography.link.color),
    linkDecoration: _get(theme, 'typography.link.decoration', typographyTheme.typography.link.decoration),
    linkHoverColor: lighten(0.1, _get(theme, 'typography.link.color', typographyTheme.typography.link.color)),
    linkHoverDecoration: _get(theme, 'typography.link.hoverDecoration', typographyTheme.typography.link.hoverDecoration),
    bodyColor: _get(theme, 'base.colors.dark', baseTheme.base.colors.dark),
    bodyBg: _get(theme, 'base.body.background', baseTheme.base.body.background),
    fontSizeBase: rem(_get(theme, 'typography.base.fontSize', typographyTheme.typography.base.fontSize)),
    paragraphMarginBottom: rem(_get(theme, 'typography.paragraph.margin', typographyTheme.typography.paragraph.margin)),
    lineHeightBase: _get(theme, 'typography.base.lineHeight', typographyTheme.typography.base.lineHeight),
    labelMarginBottom: _get(theme, 'typography.label.marginBottom', typographyTheme.typography.label.marginBottom)
  };
};

var rebootThemed = function rebootThemed(_ref2) {
  var theme = _ref2.theme;
  return reboot(globalOptions({
    theme: theme
  }));
};

var rebootScrollbar = function rebootScrollbar(_ref3) {
  var theme = _ref3.theme;

  var isEnabledOnBody = _get(theme, 'base.scrollbar.onBody', baseTheme.base.scrollbar.onBody);

  if (!isEnabledOnBody) {
    return null;
  }

  return css(["", ""], baseScrollbarStyles);
};

var GlobalStyle = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n"])), rebootThemed, rebootScrollbar);
export default GlobalStyle;